var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { asyncPoll } from './polling';
export var getUserGroupDetails = function (type, apiBaseurl, lendiAuthToken, applicationId, customerId, enableHistoricalThreads) { return __awaiter(void 0, void 0, void 0, function () {
    var requestURL;
    return __generator(this, function (_a) {
        // chat 3.2
        if (enableHistoricalThreads) {
            requestURL = "".concat(apiBaseurl, "/v2/chat/application/").concat(applicationId, "/thread");
        }
        else {
            // chat 3.0 can be removed after release of Chat 3.2
            requestURL = applicationId
                ? "".concat(apiBaseurl, "/v2/chat/user-group?applicationId=").concat(applicationId)
                : type === 'customer'
                    ? "".concat(apiBaseurl, "/v2/chat/user-group")
                    : "".concat(apiBaseurl, "/v2/chat/user-group?customerId=").concat(customerId);
        }
        return [2 /*return*/, getUserGroupRequest(type, lendiAuthToken, requestURL, apiBaseurl)];
    });
}); };
var getUserGroupRequest = function (type, lendiAuthToken, requestURL, apiBaseurl) { return __awaiter(void 0, void 0, void 0, function () {
    var config, userGroupCall;
    return __generator(this, function (_a) {
        config = {
            apiBaseurl: apiBaseurl,
            headers: {
                Authorization: "Bearer ".concat(lendiAuthToken),
                'Content-Type': 'application/json',
            },
        };
        userGroupCall = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a, status_1, data, _b, userGroupHash, teamMembers, migratedToConversation, agentsRemoved, err_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios.get(requestURL, config)];
                    case 1:
                        _a = _c.sent(), status_1 = _a.status, data = _a.data;
                        if (status_1 === 200) {
                            _b = data.data, userGroupHash = _b.userGroupHash, teamMembers = _b.teamMembers, migratedToConversation = _b.migratedToConversation, agentsRemoved = _b.agentsRemoved;
                            return [2 /*return*/, Promise.resolve({
                                    userGroupHash: userGroupHash,
                                    teamMembers: teamMembers,
                                    migratedToConversation: migratedToConversation,
                                    agentsRemoved: agentsRemoved,
                                })];
                        }
                        else if (status_1 === 401) {
                            return [2 /*return*/, null];
                        }
                        else {
                            throw new Error("getUserGroup: get user-group endpoint error");
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        return [2 /*return*/, Promise.reject(err_1)];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (type === 'broker') {
            return [2 /*return*/, userGroupCall()];
        }
        else {
            return [2 /*return*/, asyncPoll(function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        return [2 /*return*/, userGroupCall()];
                    });
                }); }, 1000, // interval - 1 sec
                20000 // timeout - 20 sec
                )];
        }
        return [2 /*return*/];
    });
}); };
//# sourceMappingURL=index.js.map